
import React, { useEffect, useState } from "react";
import { DashboardOutlined, ProfileOutlined, HistoryOutlined, SaveOutlined, SettingOutlined, AppstoreOutlined } from "@ant-design/icons"
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import { setWsHeartbeat } from "ws-heartbeat/client";
import CreateProfileModal from "./create-profile-modal";


import fetchBots from '../common/helpers/fetch-bots';
import fetchProfiles from '../common/helpers/fetch-profiles';
import createProfile from '../common/helpers/create-profile';
import updateBot from '../common/helpers/update-bot';
import createOrders from '../common/helpers/create-orders';
import cancelOrder from '../common/helpers/cancel-order';
import cancelRebalanceOrder from '../common/helpers/cancel-rebalance-order';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
} from '@ant-design/icons';

const { Option } = Select;
const { TabPane } = Tabs;


const key = 'updatable';

// const Profiles = {
//   binance: {
//     exchange: "binanceusdm",
//     api_key: "1a3321381e9f2e87cdc1a2e9489936bb0e5e059043617ff723508a2b0d6cd575",
//     api_secret: "0aa570260b8082e9130030eae9fefefee70e55bde31865494224b124983b3aed"
//   }
// }

const priceSources = [{ value: 'binance', label: 'Binance' }];

const Dashboard = () => {

  const [collapsed, setCollapsed] = useState(false);
  const [displaySelectProfile, setDisplaySelectProfile] = useState(false);
  const [displayCreateProfile, setDisplayCreateProfile] = useState(false);

  const [orders, setOrders] = useState([]);
  const [placedOrders, setPlacedOrders] = useState([]);
  const [rebalanceOrders, setRebalanceOrders] = useState([]);
  const [orderItem, setOrderItem] = useState({
    id: null,
    symbol: null,
    side: null,
    minimum_size: null,
    maximum_size: null,
    spread: null,
    sensitivity: null,
    timer: null,
    bot_id: null,
    rebalance: null,
    source: null,
    source_symbol: null,
    rebalance_symbol: null,
    conversion: null,
    order_status: null,
  });

  const [hostProfile, setHostProfile] = useState();
  const [profiles, setProfiles] = useState([]);

  const [selectedBot, setSelectedBot] = useState({});

  const [serverUnresponsive, setServerUnresponsive] = useState(false);

  useEffect(() => {
    fetchBots().then(res => {
      if (res?.length > 0) {
        setSelectedBot(res[0])
        setHostProfile(res[0].host)
      }
    })
    fetchProfiles().then(res => {
      setProfiles(res || [])
    })
  }, [])

  useEffect(() => {
    const client = new WebSocket('wss://localhost:8080');

    client.onmessage = ({ data }) => {
      const parsedData = JSON.parse(data);
      console.log({ SOCKET: parsedData })

      if (parsedData.message === 'order_create') {
        console.log({ parsedData })
        if (parsedData.error) {
          message.destroy({ content: parsedData.error, key: 'error' });
          message.destroy(key);
          message.error({ content: parsedData.error, key: 'error' });
        }

        setOrders(orders.filter(order => order.id !== parsedData.order.id));
        setPlacedOrders(previousState => [...previousState, parsedData.order]);

        if (!parsedData.error) {
          if (orders.length == 0) {
            message.success({ content: 'Orders Placed!', key, duration: 2 });
          }
        }
      }
      else if (parsedData.message === 'order_cancel') {
        setPlacedOrders(previousState => {
          let updatedPlacedOrders = [...previousState];
          const Index = updatedPlacedOrders.findIndex(order => order.id === parsedData.order_id);
          if (Index !== -1) {
            updatedPlacedOrders[Index].order_status = 'canceled';
          }
          return updatedPlacedOrders;
        });
      }
      else if (parsedData.message === 'trade_success') {
        if (parsedData.isRebalance) {
          setRebalanceOrders(previousState => {
            let updatedRebalanceOrders = [...previousState];
            const Index = updatedRebalanceOrders.findIndex(order => order.order_id === parsedData.trade.order);
            if (Index !== -1) {
              updatedRebalanceOrders[Index].order_status = 'filled';

            }
            return updatedRebalanceOrders;
          });
        } else {
          setPlacedOrders(previousState => {
            let updatedPlacedOrders = [...previousState];
            const Index = updatedPlacedOrders.findIndex(order => order.order_id === parsedData.trade.order);
            if (Index !== -1) {
              updatedPlacedOrders[Index].order_status = 'filled';

            }
            return updatedPlacedOrders;
          });
        }

      }
      else if (parsedData.message === 'rebalance_order_create') {
        // there is no id, use order_id
        if (parsedData.error) {
          message.destroy({ content: parsedData.error, key: 'error' });
          message.destroy(key);
          message.error({ content: parsedData.error, key: 'error' });
        }

        console.log({ GG: parsedData.order })
        // setPlacedOrders(previousState => [...previousState].filter(order => order.order_id !== parsedData.order.order_id));
        setRebalanceOrders(previousState => [...previousState, parsedData.order]);
      }
      else if (parsedData.message === 'error') {
        message.destroy({ content: parsedData.error, key: 'error' });
        message.destroy(key);
        message.error({ content: parsedData.error, key: 'error' });
      }
    }

    client.onclose = () => {
      setServerUnresponsive(true);
    }
    // setWsHeartbeat(client, '{"kind":"ping"}');
    return () => client.disconnect();
  }, [])

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const showModal = () => {
    setDisplaySelectProfile(true);
  };

  const handleOk = () => {
    setDisplaySelectProfile(false);
  };

  const handleCancel = () => {
    setDisplaySelectProfile(false);
  };

  function onSearch(val) {
    console.log('search:', val);
  }
  const openMessage = () => {
    message.loading({ content: 'Waiting...', key, duration: 0 });
    // setTimeout(() => {
    //   // openNotificationWithIcon('success');
    //   message.success({ content: 'Orders Placed!', key, duration: 2 });
    // }, 10000);
  };

  const openNotificationWithIcon = type => {
    notification[type]({
      message: 'New Orders',
      description:
        '--',
    });
  };

  const addOrder = () => {
    if (!orderItem.symbol) {
      message.error('Please enter symbol');
      return;
    }
    if (!orderItem.side) {
      message.error('Please select size');
      return;
    }
    if (!orderItem.minimum_size) {
      message.error('Please enter minimum size');
      return;
    }
    if (!orderItem.maximum_size) {
      message.error('Please enter maximum size');
      return;
    }
    if (orderItem.maximum_size < orderItem.minimum_size) {
      message.error('maximum size cannot be lower than minimum size');
      return;
    }
    if (!orderItem.rebalance) {
      message.error('Please select rebalance profile');
      return;
    }
    if (!orderItem.source) {
      message.error('Please select source');
      return;
    }
    if (!orderItem.source_symbol) {
      message.error('Please enter source symbol');
      return;
    }
    if (!orderItem.rebalance_symbol) {
      message.error('Please enter rebalance symbol');
      return;
    }
    if (!orderItem.source_symbol) {
      message.error('Please enter source symbol');
      return;
    }
    if (!orderItem.spread) {
      message.error('Please enter spread');
      return;
    }
    if (!orderItem.timer) {
      message.error('Please enter timer');
      return;
    }

    let newOrderItem = Object.assign({}, orderItem);
    if (!orderItem.sensitivity) {
      newOrderItem.sensitivity = orderItem.spread / 2
    }
    newOrderItem.rebalance = JSON.parse(orderItem.rebalance);

    newOrderItem.id = uuidv4();
    newOrderItem.bot_id = selectedBot.id;
    newOrderItem.minimum_size = parseFloat(newOrderItem.minimum_size);
    newOrderItem.maximum_size = parseFloat(newOrderItem.maximum_size);

    console.log({
      newOrderItem
    })
    setOrders([...orders, newOrderItem]);

    console.log({ orders })
    setOrderItem({
      symbol: null,
      side: null,
      minimum_size: null,
      maximum_size: null,
      spread: null,
      sensitivity: null,
      timer: null,
      bot_id: null,
      rebalance: null,
      source: null,
      source_symbol: null,
      rebalance_symbol: null,
      conversion: null,
    })
  }
  const createRandomOrder = () => {

    function get_random(list) {
      return list[Math.floor((Math.random() * list.length))];
    }
    function randomFromInterval(min, max) { // min and max included 
      return Math.random() * (max - min) + min
    }
    let randomOrder = [
      {
        id: uuidv4(),
        symbol: get_random(["BTC/USDT", "ETH/BTC", "GG/REASD", "AVAX/USDT", "DOT/USDT", "ASDSAD/asdasd", "BTC/USDT", "BTC/USDT", "BTC/USDT", "BTC/USDT"]),
        sensitivity: randomFromInterval(0.1, 0.5),
        source: "binance",
        side: get_random(["buy", "sell"]),
        minimum_size: 0.001,
        maximum_size: 0.003,
        spread: randomFromInterval(0.001, 0.5),
        timer: randomFromInterval(15, 125),
        source_symbol: get_random(["BTC/USDT", "ETH/BTC", "GG/REASD", "AVAX/USDT", "DOT/USDT", "ASDSAD/asdasd", "BTC/USDT", "BTC/USDT", "BTC/USDT", "BTC/USDT"]),
        rebalance_symbol: "BTC/USDT",
        conversion: null,
        rebalance: {
          exchange: "binanceusdm",
          api_key: "1a3321381e9f2e87cdc1a2e9489936bb0e5e059043617ff723508a2b0d6cd575",
          api_secret: "0aa570260b8082e9130030eae9fefefee70e55bde31865494224b124983b3aed"
        },
        bot_id: 1
      },
    ]

    setOrders([...orders, get_random(randomOrder)]);

  }
  const placeOrders = () => {
    console.log({ orders })
    createOrders(orders).then(res => {
      openMessage()
      console.log({ placedOrders: res })
    })
  }

  const onProfileCreate = (data) => {
    createProfile(data).then(() => {
      fetchProfiles().then(res => {
        setProfiles(res);
      }).catch(err => {
        console.log({ err })
      })
    })
  }
  const onSelectProfile = (value) => {
    const parsedObject = JSON.parse(value);
    setHostProfile(parsedObject);
    updateBot(selectedBot.id, { host_id: parsedObject.id })
  }
  return (<>
    {serverUnresponsive
      ?
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", color: "white", fontSize: 20 }}>
        Server Disconnected, Please Refresh
      </div>
      :
      <div style={{ height: "100%" }}>
        <Modal title="Change Source" visible={displaySelectProfile} onOk={() => { setDisplaySelectProfile(false); }} onCancel={() => { setDisplaySelectProfile(false); }}>
          <div style={{ display: "flex", flexDirection: "row", gap: 15 }}>
            <Select
              style={{ width: 300 }}
              showSearch
              placeholder="Select Host Profile"
              optionFilterProp="children"
              onChange={(value) => {
                onSelectProfile(value)
              }}
              onSearch={onSearch}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {profiles.map(profile => <Option value={JSON.stringify(profile)}>{profile.name}</Option>)}
            </Select>
            <div>
              <Button onClick={() => {
                setDisplayCreateProfile(true)
              }} type="primary">Create Profile</Button>
            </div>
          </div>
        </Modal>

        <CreateProfileModal displayCreateProfile={displayCreateProfile} setDisplayCreateProfile={setDisplayCreateProfile} createProfile={onProfileCreate} />
        <div style={{ height: 30, backgroundColor: "black", color: "white", padding: 5 }}><AppstoreOutlined /> Robolla-V3</div>
        <div style={{ display: "flex", flexDirection: "row", height: "95%" }}>
          <div style={{ display: "flex", flexDirection: "column", backgroundColor: "#303236", width: 200, borderRight: "1px solid #4c4c4c", color: "#cccccc", padding: 10 }}>
            <div style={{ margin: "15px 0", fontSize: 17, cursor: "pointer" }} ><DashboardOutlined /> Dashboard</div>
            <div style={{ margin: "15px 0", fontSize: 17, cursor: "pointer" }} ><ProfileOutlined /> Profiles</div>
            <div style={{ margin: "15px 0", fontSize: 17, cursor: "pointer" }} ><HistoryOutlined /> Trade History</div>
            <div style={{ margin: "15px 0", fontSize: 17, cursor: "pointer" }} ><SaveOutlined />  Saved Bot Profiles</div>
            <div style={{ margin: "15px 0", fontSize: 17, cursor: "pointer" }} ><SettingOutlined />  Settings</div>
            <Button type="primary" onClick={toggleCollapsed} style={{ marginBottom: 16 }}>
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </Button>
          </div>
          <div style={{ display: "flex", flexDirection: "column", marginTop: 50, color: "#cccccc", fontSize: 25, marginLeft: 10, width: "100%" }}>
            <div><DashboardOutlined />  Dashboard</div>
            <div style={{ display: "flex", flexDirection: "row", gap: 10, marginRight: 10, height: "90%" }}>
              <div style={{ flex: 5, display: "flex", flexDirection: "column", backgroundColor: "#303236", borderRadius: 5, border: "1px solid #4c4c4c" }}>
                <div style={{ fontSize: 17, marginTop: 5, marginLeft: 5 }}>Order Creation</div>
                <hr style={{ backgroundColor: "white", width: "98%", margin: 1 }} />

                <div style={{ maxHeight: 800, overflowY: "auto" }}>
                  <table style={{ marginTop: 30 }}>
                    <tr>
                      <th style={{ fontSize: 16, border: "1px solid #cccccc" }} >Symbol</th>
                      <th style={{ fontSize: 16, border: "1px solid #cccccc" }} >Rebalance</th>
                      <th style={{ fontSize: 16, border: "1px solid #cccccc" }} >Source</th>
                      <th style={{ fontSize: 16, border: "1px solid #cccccc" }} >Source Symbol</th>
                      <th style={{ fontSize: 16, border: "1px solid #cccccc" }} >Rebalance Symbol</th>
                      <th style={{ fontSize: 16, border: "1px solid #cccccc" }} >Side</th>
                      <th style={{ fontSize: 16, border: "1px solid #cccccc" }} >Minimum Size</th>
                      <th style={{ fontSize: 16, border: "1px solid #cccccc" }} >Maximum Size</th>
                      <th style={{ fontSize: 16, border: "1px solid #cccccc" }} >Spread</th>
                      <th style={{ fontSize: 16, border: "1px solid #cccccc" }} >Sensitivity</th>
                      <th style={{ fontSize: 16, border: "1px solid #cccccc" }} >Conversion</th>
                      <th style={{ fontSize: 16, border: "1px solid #cccccc" }} >Timer</th>
                      <th style={{ fontSize: 16, border: "1px solid #cccccc" }} >Actions</th>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid #cccccc", padding: "10px" }}>
                        <Input value={orderItem.symbol} onChange={(e) => {
                          setOrderItem({
                            ...orderItem,
                            symbol: e.target.value
                          })
                        }} style={{ backgroundColor: "#1E2329", color: "white" }} placeholder="Symbol" />
                      </td>
                      <td style={{ border: "1px solid #cccccc", padding: "10px", width: 200 }}>
                        <Select value={orderItem.rebalance} onChange={(value) => {
                          setOrderItem({
                            ...orderItem,
                            rebalance: value
                          })
                        }} placeholder="Rebalance Profile" style={{ width: "100%", backgroundColor: "#1E2329", }}>
                          {profiles.map(profile => <Option value={JSON.stringify(profile)}>{profile.name}</Option>)}

                        </Select>
                      </td>
                      <td style={{ border: "1px solid #cccccc", padding: "10px", width: 120 }}>
                        <Select value={orderItem.source} onChange={(value) => {
                          setOrderItem({
                            ...orderItem,
                            source: value
                          })
                        }} placeholder="Source" style={{ width: "100%", backgroundColor: "#1E2329", }}>
                          {priceSources.map(source => <Option value={source.value}>{source.label}</Option>)}

                        </Select>
                      </td>
                      <td style={{ border: "1px solid #cccccc", padding: "10px" }}>
                        <Input
                          value={orderItem.source_symbol}
                          onChange={(e) => {
                            setOrderItem({
                              ...orderItem,
                              source_symbol: e.target.value
                            })
                          }}
                          style={{ backgroundColor: "#1E2329", color: "white" }} placeholder="Source Symbol" />
                      </td>
                      <td style={{ border: "1px solid #cccccc", padding: "10px" }}>
                        <Input
                          value={orderItem.rebalance_symbol}
                          onChange={(e) => {
                            setOrderItem({
                              ...orderItem,
                              rebalance_symbol: e.target.value
                            })
                          }}
                          style={{ backgroundColor: "#1E2329", color: "white" }} placeholder="Rebalance Symbol" />
                      </td>
                      <td style={{ border: "1px solid #cccccc", padding: "10px", width: 120 }}>
                        <Select
                          value={orderItem.side}
                          onChange={(value) => {
                            setOrderItem({
                              ...orderItem,
                              side: value
                            })
                          }}
                          placeholder="Side" style={{ width: "100%", backgroundColor: "#1E2329", }}>
                          <Option value="buy">Buy</Option>
                          <Option value="sell">Sell</Option>
                        </Select>
                      </td>
                      <td style={{ border: "1px solid #cccccc", padding: "10px" }}>
                        <Input
                          value={orderItem.minimum_size}
                          onChange={(e) => {
                            setOrderItem({
                              ...orderItem,
                              minimum_size: e.target.value
                            })
                          }}
                          style={{ backgroundColor: "#1E2329", color: "white" }} placeholder="Minimum Size" />
                      </td>
                      <td style={{ border: "1px solid #cccccc", padding: "10px" }}>
                        <Input
                          value={orderItem.maximum_size}
                          onChange={(e) => {
                            setOrderItem({
                              ...orderItem,
                              maximum_size: e.target.value
                            })
                          }}
                          style={{ backgroundColor: "#1E2329", color: "white" }} placeholder="Maximum Size" />
                      </td>
                      <td style={{ border: "1px solid #cccccc", padding: "10px" }}>
                        <Input
                          onChange={(e) => {
                            setOrderItem({
                              ...orderItem,
                              spread: e.target.value
                            })
                          }}
                          value={orderItem.spread} style={{ backgroundColor: "#1E2329", color: "white" }} placeholder="Spread" />
                      </td>

                      <td style={{ border: "1px solid #cccccc", padding: "10px", }}>
                        <Input
                          value={orderItem.sensitivity}
                          onChange={(e) => {
                            setOrderItem({
                              ...orderItem,
                              sensitivity: e.target.value
                            })
                          }}
                          style={{ backgroundColor: "#1E2329", color: "white" }} placeholder="Sensitivity" />
                      </td>

                      <td style={{ border: "1px solid #cccccc", padding: "10px" }}>
                        <Input
                          value={orderItem.conversion}
                          onChange={(e) => {
                            setOrderItem({
                              ...orderItem,
                              conversion: e.target.value
                            })
                          }}
                          style={{ backgroundColor: "#1E2329", color: "white" }} placeholder="Conversion" />
                      </td>

                      <td style={{ border: "1px solid #cccccc", padding: "10px" }}>
                        <Input
                          onChange={(e) => {
                            setOrderItem({
                              ...orderItem,
                              timer: e.target.value
                            })
                          }}
                          value={orderItem.timer} style={{ backgroundColor: "#1E2329", color: "white" }} placeholder="Timer" />
                      </td>
                      <td style={{ border: "1px solid #cccccc", padding: "10px" }}>
                        <div style={{ fontSize: 15, position: "relative", top: 3 }}>
                          <Button onClick={() => {
                            addOrder();
                            // createRandomOrder();
                          }}>Add Order</Button>
                        </div>
                      </td>
                    </tr>

                    {orders.map(x => {
                      return <tr>
                        <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center" }} >{x.symbol || '-'}</td>
                        <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center" }} >{x?.rebalance?.exchange || '-'}</td>
                        <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center" }} >{x.source || '-'}</td>
                        <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center" }} >{x.source_symbol || '-'}</td>
                        <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center" }} >{x.rebalance_symbol || '-'}</td>
                        <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center" }} >{x.side || '-'}</td>
                        <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center" }} >{x.minimum_size || '-'}</td>
                        <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center" }} >{x.maximum_size || '-'}</td>
                        <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center" }} >{x.spread || '-'}</td>
                        <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center" }} >{x.sensitivity || x.spread / 2}</td>
                        <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center" }} >{x.conversion || '-'}</td>
                        <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center" }} >{x.timer || '-'}</td>
                        <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center" }} >
                          <div style={{ display: "flex", flexDirection: "row", padding: 5, gap: 5 }}>
                            <span><Button>Edit</Button></span>
                            <span><Button onClick={() => { setOrders(orders.filter(order => order.id !== x.id)) }} type="primary" danger>Delete</Button></span>
                          </div>
                        </td>
                      </tr>
                    })}

                  </table>
                </div>


                <div style={{ fontSize: 15, position: "relative", top: 6, display: "flex", justifyContent: "flex-end", marginTop: 20, gap: 10 }}>
                  <Button onClick={() => {
                  }}>Pause Orders</Button>
                  <Button type="primary" onClick={() => {
                    placeOrders();
                  }}>Place Orders</Button>
                </div>
                {/* <div style={{fontSize:17, marginTop:25, marginLeft:5}}>Orders</div>
            <hr style={{backgroundColor:"white", width:"100%", margin:1}}/> */}
                <Tabs defaultActiveKey="1" style={{ marginTop: 25, marginLeft: 10 }}>
                  <TabPane tab={<span style={{ color: "#cccccc" }}>Open Orders</span>} key="1">
                    <div style={{ maxHeight: 800, overflowY: "auto" }}>
                      <table style={{ padding: 5, width: "98%" }}>
                        <tr>
                          <th style={{ fontSize: 16, border: "1px solid #6d6d6e", color: "#cccccc" }} >Symbol</th>
                          <th style={{ fontSize: 16, border: "1px solid #6d6d6e", color: "#cccccc" }} >Host</th>
                          <th style={{ fontSize: 16, border: "1px solid #6d6d6e", color: "#cccccc" }} >Rebalance</th>
                          <th style={{ fontSize: 16, border: "1px solid #6d6d6e", color: "#cccccc" }} >Source</th>
                          <th style={{ fontSize: 16, border: "1px solid #6d6d6e", color: "#cccccc" }} >Side</th>
                          <th style={{ fontSize: 16, border: "1px solid #6d6d6e", color: "#cccccc" }} >Size</th>
                          <th style={{ fontSize: 16, border: "1px solid #6d6d6e", color: "#cccccc" }} >Spread</th>
                          <th style={{ fontSize: 16, border: "1px solid #6d6d6e", color: "#cccccc" }} >Sensitivity</th>
                          <th style={{ fontSize: 16, border: "1px solid #6d6d6e", color: "#cccccc" }} >Order Price</th>
                          <th style={{ fontSize: 16, border: "1px solid #6d6d6e", color: "#cccccc" }} >Timer</th>
                          <th style={{ fontSize: 16, border: "1px solid #6d6d6e", color: "#cccccc" }} >Status</th>
                          <th style={{ fontSize: 16, border: "1px solid #6d6d6e", color: "#cccccc", width: 120 }} >Action</th>
                        </tr>

                        {placedOrders.map(x => {
                          return <tr>
                            <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center", color: "#cccccc" }} >{x.symbol || '-'}</td>
                            <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center", color: "#cccccc" }} >{x.host || '-'}</td>
                            <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center", color: "#cccccc" }} >{x?.rebalance?.exchange || '-'}</td>
                            <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center", color: "#cccccc" }} >{x.source || '-'}</td>
                            <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center", color: "#cccccc" }} >{x.side || '-'}</td>
                            <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center", color: "#cccccc" }} >{x.size || '-'}</td>
                            <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center", color: "#cccccc" }} >{x.spread || '-'}</td>
                            <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center", color: "#cccccc" }} >{x.sensitivity || '-'}</td>
                            <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center", color: "#cccccc" }} >{x.order_price || '-'}</td>
                            <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center", color: "#cccccc" }} >{x.timer || '-'}</td>
                            <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center", color: "#cccccc" }} >{x.order_status || '-'}</td>
                            <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center", color: "#cccccc" }} >{x.order_status === 'open' &&
                              <div style={{ display: "flex", flexDirection: "row", padding: 5, gap: 15, justifyContent: "center", }}>
                                <span><Button onClick={() => {
                                  message.loading({ content: 'Waiting...', key: 'cancel', duration: 0 });
                                  cancelOrder(x.id).then(res => {
                                    if (res.error) {
                                      message.error(res.error)
                                    }
                                    setPlacedOrders(previousState => {
                                      let updatedPlacedOrders = [...previousState];
                                      const Index = updatedPlacedOrders.findIndex(order => order.id === res.id);
                                      if (Index !== -1) {
                                        updatedPlacedOrders[Index].order_status = 'canceled';
                                      }
                                      return updatedPlacedOrders;
                                    });
                                    message.destroy('cancel')
                                    console.log(res)
                                  })
                                }} type="primary" danger>Cancel</Button></span>
                              </div>
                            }</td>
                          </tr>
                        })}

                      </table>
                    </div>


                  </TabPane>
                  <TabPane tab={<span style={{ color: "#cccccc" }}>Rebalance Orders</span>} key="2">
                    <table style={{ padding: 5, width: "98%" }}>
                      <tr>
                        <th style={{ fontSize: 16, border: "1px solid #6d6d6e", color: "#cccccc" }} >Symbol</th>
                        <th style={{ fontSize: 16, border: "1px solid #6d6d6e", color: "#cccccc" }} >Side</th>
                        <th style={{ fontSize: 16, border: "1px solid #6d6d6e", color: "#cccccc" }} >Size</th>
                        <th style={{ fontSize: 16, border: "1px solid #6d6d6e", color: "#cccccc" }} >Order Price</th>
                        <th style={{ fontSize: 16, border: "1px solid #6d6d6e", color: "#cccccc" }} >Status</th>
                        <th style={{ fontSize: 16, border: "1px solid #6d6d6e", color: "#cccccc", width: 120 }} >Action</th>
                      </tr>

                      {rebalanceOrders.map(x => {
                        return <tr>
                          <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center", color: "#cccccc" }} >{x.symbol || '-'}</td>
                          <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center", color: "#cccccc" }} >{x.side || '-'}</td>
                          <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center", color: "#cccccc" }} >{x.size || '-'}</td>
                          <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center", color: "#cccccc" }} >{x.order_price || '-'}</td>
                          <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center", color: "#cccccc" }} >{x.order_status || '-'}</td>
                          <td style={{ fontSize: 16, border: "1px solid #cccccc", textAlign: "center", color: "#cccccc" }} >{x.order_status === 'open' &&
                            <div style={{ display: "flex", flexDirection: "row", padding: 5, gap: 15, justifyContent: "center", }}>
                              <span><Button onClick={() => {
                                message.loading({ content: 'Waiting...', key: 'cancel', duration: 0 });
                                cancelRebalanceOrder(x.order_id).then(res => {
                                  if (res.error) {
                                    message.error(res.error)
                                  }
                                  setRebalanceOrders(previousState => {
                                    let updatedRebalanceOrders = [...previousState];
                                    const Index = updatedRebalanceOrders.findIndex(order => order.order_id === res.order_id);
                                    if (Index !== -1) {
                                      updatedRebalanceOrders[Index].order_status = 'canceled';
                                    }
                                    return updatedRebalanceOrders;
                                  });
                                  message.destroy('cancel')
                                })
                              }} type="primary" danger>Cancel</Button></span>
                            </div>
                          }</td>
                        </tr>
                      })}

                    </table>
                  </TabPane>
                </Tabs>

              </div>
              <div style={{ flex: 1, display: "flex", flexDirection: "column", backgroundColor: "#303236", borderRadius: 5, border: "1px solid #4c4c4c" }}>
                <div style={{ fontSize: 17, marginTop: 5, marginLeft: 5 }}>Selected Host Profile:</div>
                <div style={{ fontSize: 17, marginTop: 5, marginLeft: 5, fontWeight: "700", display: "flex", justifyContent: "space-between", margin: "0 5px" }}>{hostProfile?.name || "-"} <Button onClick={() => { showModal() }}>Change</Button></div>
                <hr style={{ backgroundColor: "white", width: "98%", margin: 1 }} />
              </div>
            </div>

          </div>
        </div>
      </div>}
  </>


  );
};

export default Dashboard;